"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genPrmLink = exports.sendPrmByParams = exports.sendPrmBylink = void 0;
var string_1 = require("utils/string");
function doRequest(url) {
    if (!url) {
        return;
    }
    return (document.createElement("img").src = url);
}
exports.sendPrmBylink = function (url) {
    return doRequest(url);
};
var requestSource = "/c.gif";
function getRequestUri() {
    return "//" + location.host + requestSource;
}
exports.sendPrmByParams = function (params) {
    return doRequest(genPrmLink(getRequestUri(), params));
};
function genPrmLink(url, prm) {
    if (url === void 0) { url = ""; }
    if (url === undefined || url === "") {
        return "";
    }
    if (url.startsWith("#") || url.match(/prm=(?=\d+\.)/)) {
        return url;
    }
    var postUrl = url;
    var site = prm.site, pageType = prm.pageType, floorIndex = prm.floorIndex, position = prm.position;
    var prmString = [site, pageType, floorIndex.toString(), position.toString()]
        .filter(function (v) { return !string_1.isUndefinedOrEmpty(v); })
        .join(".");
    var startChat = "?";
    if (postUrl.includes("?")) {
        startChat = postUrl.endsWith("&") ? "" : "&";
    }
    return "" + postUrl + startChat + "prm=" + prmString;
}
exports.genPrmLink = genPrmLink;
